import { IconButton } from '@mui/material'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import { FullscreenExit } from '@mui/icons-material'
import androidWebViewApi from 'utilities/androidWebViewApi'
import { useDispatch } from 'react-redux'
import { TOGGLE_FULLSCREEN_STATE } from 'store/reducers/ui/appState.reducer'
import { useAppSelector } from 'store/useStoreHook'

const FullScreenButton = () => {
    const dispatch = useDispatch()

    const isFullscreen = useAppSelector(
        (state) => state.ui.appState.isFullscreen,
    )

    const toggleFullscreen = () => {
        dispatch({ type: TOGGLE_FULLSCREEN_STATE })
        if (androidWebViewApi.isRunInAndroidWebView()) {
            androidWebViewApi.toggleFullscreen()
        } else {
            if (document.fullscreenElement) {
                document.exitFullscreen()
            } else {
                document.documentElement.requestFullscreen()
            }
        }
    }

    return (
        <IconButton
            size="small"
            aria-label="toggle fullscreen"
            color="inherit"
            onClick={toggleFullscreen}
        >
            {isFullscreen ? <FullscreenExit /> : <FullscreenIcon />}
        </IconButton>
    )
}

export default FullScreenButton
